function headerscroll() {
  class Navigation {
    constructor(element, options = {}){
      this.root = element;
      this.rootHeight = this.root.offsetHeight;
      this.windowScrollTop = null;
      this.windowScrollTopPrev = window.scrollY;
      this.initWindowScrollListener();
    }
    
    initWindowScrollListener(){
      window.addEventListener("scroll", () => {

        this.windowScrollTop = window.scrollY;
        this.headerScrollEvent()
      })
    }
    
    headerScrollEvent(){
      // check if current window scroll top greather than bottom header on load
      if (this.windowScrollTop > this.rootHeight) {
        // if old window scroll smaller than current window, hide the header
        if (this.windowScrollTopPrev < this.windowScrollTop) {
          this.root.classList.add('is-hidden');
          this.root.classList.remove('is-visible');
        } else {
          // show header
          this.root.classList.remove('is-hidden');
          this.root.classList.add('is-visible');
        }
        // set current scroll top to previeous scroll top of window
        this.windowScrollTopPrev = this.windowScrollTop;
      } else {
          this.root.classList.remove('is-hidden');
          this.root.classList.remove('is-visible');
      }
    }
    
  }
  
  const navbar = document.querySelector("#header");
  const navigation = new Navigation(navbar)
  
  
}

export default {
    init: function () {
      headerscroll();
    }
};